const config = {
  merchant: "tcglivevn",
  defaultLang: "VI",
};
export default config;
